import React, { Component } from 'react';
import { Field, reduxForm } from 'redux-form';
import { Grid, Form } from 'semantic-ui-react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';

import { InputField } from 'Common/SemanticWrapper';
import { TitledCard } from 'Components';
import { VerificationSelectionFieldEnum as Fields } from 'Common/FieldEnum';
import { VERIFICATION_SELECTION_FORM_NAME, InputMode } from 'Common/FormEnum';
import { defaultDateFormat } from 'Common/GeneralHelper';

class VerificationSelectionFormContainer extends Component {
  renderApprovedCategorical = () => {
    if (
      this.props.initialValues &&
      this.props.initialValues[Fields.ShowApprovedCategoricalRow]
    ) {
      return (
        <Grid.Row>
          <Grid.Column>
            Total number of approved categorical applications
          </Grid.Column>
          <Grid.Column>
            <Field
              component={InputField}
              name={Fields.ApprovedCategorical}
              type={'text'}
              readOnly
            />
          </Grid.Column>
          <Grid.Column>
            <Field
              component={InputField}
              name={Fields.ApprovedCategoricalAsOf}
              type={'text'}
              readOnly
            />
          </Grid.Column>
          <Grid.Column />
        </Grid.Row>
      );
    }
  };

  renderToBeVerifiedCategorical = () => {
    if (
      this.props.initialValues &&
      this.props.initialValues[Fields.ShowToBeVerifiedCategoricalRow]
    ) {
      return (
        <Grid.Row>
          <Grid.Column>
            Number of Categorical Applications to verify
          </Grid.Column>
          <Grid.Column>
            <Field
              component={InputField}
              mode={InputMode.Integer}
              name={Fields.ToBeVerifiedCategorical}
              type={'text'}
              readOnly
            />
          </Grid.Column>
          <Grid.Column>
            <Field
              component={InputField}
              mode={InputMode.Integer}
              name={Fields.ToBeVerifiedCategoricalAsOf}
              type={'text'}
              readOnly
            />
          </Grid.Column>
          <Grid.Column>
            <Field
              component={InputField}
              mode={InputMode.Integer}
              name={Fields.ToBeVerifiedCategoricalAdjusted}
              type={'text'}
              disabled={this.props.phase < 2 || this.props.isClosed}
            />
          </Grid.Column>
        </Grid.Row>
      );
    }
  };

  render() {
    const { handleSubmit } = this.props;
    return (
      <div>
        <Form onSubmit={handleSubmit}>
          <TitledCard
            title={
              this.props.initialValues &&
              this.props.initialValues[Fields.SelectionTypeDescription]
            }
          >
            <Grid columns={4}>
              <Grid.Row>
                <Grid.Column />
                <Grid.Column>
                  Projected &nbsp; (
                  {this.props.initialValues &&
                    this.props.initialValues[Fields.EarlyText]}{' '}
                  )
                </Grid.Column>
                <Grid.Column>
                  Official &nbsp; (
                  {this.props.initialValues &&
                    defaultDateFormat(
                      this.props.initialValues[Fields.AsOfDate]
                    )}{' '}
                  )
                </Grid.Column>
                <Grid.Column>
                  Adjusted &nbsp; (
                  {this.props.initialValues &&
                    this.props.initialValues[Fields.AdjustedText]}
                  )
                </Grid.Column>
              </Grid.Row>

              <Grid.Row>
                <Grid.Column>
                  Total number of Approved Applications on file
                </Grid.Column>
                <Grid.Column>
                  <Field
                    component={InputField}
                    name={Fields.Approved}
                    type={'text'}
                    readOnly
                  />
                </Grid.Column>
                <Grid.Column>
                  <Field
                    component={InputField}
                    name={Fields.ApprovedAsOf}
                    type={'text'}
                    readOnly
                  />
                </Grid.Column>
                <Grid.Column />
              </Grid.Row>
              <Grid.Row>
                <Grid.Column style={{ marginTop: '10px' }}>
                  Number of Applications to verify
                </Grid.Column>
                <Grid.Column>
                  <Field
                    component={InputField}
                    name={Fields.ToBeVerified}
                    type={'text'}
                    readOnly
                  />
                </Grid.Column>
                <Grid.Column>
                  <Field
                    component={InputField}
                    name={Fields.ToBeVerifiedAsOf}
                    type={'text'}
                    readOnly
                  />
                </Grid.Column>
                <Grid.Column>
                  <Field
                    component={InputField}
                    mode={InputMode.Integer}
                    name={Fields.ToBeVerifiedAdjusted}
                    type={'number'}
                    disabled={this.props.phase < 2 || this.props.isClosed}
                  />
                </Grid.Column>
              </Grid.Row>
              {this.renderApprovedCategorical()}
              {this.renderToBeVerifiedCategorical()}
              <Grid.Row columns={1}>
                <Grid.Column className={'text-orange text-center'}>
                  {this.props.userMessage}
                </Grid.Column>
              </Grid.Row>
            </Grid>
          </TitledCard>
          <TitledCard title={'Configuration'}>
            <Grid>
              <Grid.Row columns={3}>
                <Grid.Column>
                  <Field
                    label={'All applications %'}
                    component={InputField}
                    name={Fields.AppPer}
                    type={'text'}
                    readOnly
                  />
                </Grid.Column>
                <Grid.Column>
                  {this.props.initialValues &&
                    this.props.initialValues[Fields.ShowErrorProneLimit] && (
                      <Field
                        label={'Error Prone Limit'}
                        component={InputField}
                        name={Fields.ErrorProneLimit}
                        type={'text'}
                        readOnly
                      />
                    )}
                </Grid.Column>
                <Grid.Column>
                  {this.props.initialValues &&
                    this.props.initialValues[Fields.ShowCaseNumberPer] && (
                      <Field
                        label={'Case# %'}
                        component={InputField}
                        name={Fields.CaseNumberPer}
                        type={'text'}
                        readOnly
                      />
                    )}
                </Grid.Column>
              </Grid.Row>
            </Grid>
          </TitledCard>
        </Form>
      </div>
    );
  }
}

const validate = (values, props) => {
  const errors = {};

  //between 2 values and in phase 2 and 3

  const { phase } = props;
  if (phase && (phase === 2 || phase === 3)) {
    if (values[Fields.ToBeVerifiedAdjusted] > values[Fields.ApprovedAsOf]) {
      errors[
        Fields.ToBeVerifiedAdjusted
      ] = `The number of applications to verify must not exceed ${
        values[Fields.ApprovedAsOf]
      }.`;
    }

    if (values[Fields.ToBeVerifiedAdjusted] < values[Fields.ToBeVerifiedAsOf]) {
      errors[
        Fields.ToBeVerifiedAdjusted
      ] = `The number of applications to verify must be greater than ${values[
        Fields.ToBeVerifiedAsOf
      ] - 1}.`;
    }

    if (values[Fields.ShowToBeVerifiedCategoricalRow]) {
      if (
        values[Fields.ToBeVerifiedCategoricalAdjusted] >
        values[Fields.ApprovedCategoricalAsOf]
      ) {
        errors[
          Fields.ToBeVerifiedCategoricalAdjusted
        ] = `The number of adjusted categorical applications must not exceed ${
          values[Fields.ApprovedCategoricalAsOf]
        }.`;
      }

      if (
        values[Fields.ToBeVerifiedCategoricalAdjusted] <
        values[Fields.ToBeVerifiedCategoricalAsOf]
      ) {
        errors[
          Fields.ToBeVerifiedCategoricalAdjusted
        ] = `The number of adjusted categorical applications must be greater than ${values[
          Fields.ToBeVerifiedCategoricalAsOf
        ] - 1}.`;
      }
    }
  }

  return errors;
};

const mapStateToProps = state => {
  return {};
};

const VerificationSelectionForm = reduxForm({
  form: VERIFICATION_SELECTION_FORM_NAME,
  validate,
  enableReinitialize: true,
})(
  withRouter(
    connect(
      mapStateToProps,
      {}
    )(VerificationSelectionFormContainer)
  )
);

export { VerificationSelectionForm };



// WEBPACK FOOTER //
// ./src/pages/verificationselection/components/VerificationSelectionForm.js